import { render, staticRenderFns } from "./BaseAvatarMessageCardComponent.html?vue&type=template&id=652130ae&"
import script from "./BaseAvatarMessageCardComponent.js?vue&type=script&lang=js&"
export * from "./BaseAvatarMessageCardComponent.js?vue&type=script&lang=js&"
import style0 from "./BaseAvatarMessageCardComponent.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports